<template>
    <div>
        <h2 class="col-12">
            Relatório {{ periodo }} -
            {{ periodo != "Anual" ? getMes(mes) : "" }} {{ ano }}
        </h2>
        <h2 class="col-12">Relatório CRAS</h2>
        <CRAS
            :mes="mes"
            :ano="ano"
            :periodo="periodo"
            :dados="dados"
            :header="false"
            :footer="false"
        />
        <h2 class="col-12">Relatório CREAS</h2>
        <CREAS
            :mes="mes"
            :ano="ano"
            :periodo="periodo"
            :dados="dados"
            :header="false"
            :footer="false"
        />
        <h2 class="col-12">Relatório Centro POP</h2>
        <CentroPop
            :mes="mes"
            :ano="ano"
            :periodo="periodo"
            :dados="dados"
            :header="false"
            :footer="false"
        />
        <h4 class="mt-2 col-12">
            Nome e cargo da pessoa responsável no CRAS pelas informações:
        </h4>
        <div class="row px-3 mx-1">
            <div class="col-8 pl-0 border-bottom">Assinatura:</div>
            <div class="col-4 border-bottom">CPF:</div>
        </div>

        <div class="footer_impressao">
            <div v-if="tecnico">
                <span><strong>Técnico responsável:</strong> {{ tecnico.nome }}</span>
                <span v-if="tecnico.profissao"><strong>Cargo:</strong> {{ tecnico.profissao }}</span>
                <span><strong>Data/Hora da emissão:</strong> {{ dataHoraAtual }}</span>
            </div>
        </div>

    </div>
</template>

<style>

    .footer_impressao {
        display: none;
    }

    /* Se quiser que apareça apenas na impressão */
    @media print {
        .footer_impressao {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: white;
            border-top: 1px solid #ccc;
            padding: 8px 20px;
            font-size: 14px;
        }
    }

    /* Adiciona o separador " - " automaticamente entre os spans */
    .footer_impressao span:not(:last-child)::after {
        content: " - ";
        margin: 0 5px;
    }

</style>

<script>
import CRAS from "./CRAS";
import CREAS from "./CREAS";
import CentroPop from "./CentroPop";
export default {
    components: { CRAS, CREAS, CentroPop },
    name: "RMA_SOCIOASSISTENCIAL",
    props: ["mes", "ano", "periodo", "unidade", "dados"],
    data() {
        return {
            meses: [
                { id: "01", value: "Janeiro" },
                { id: "02", value: "Fevereiro" },
                { id: "03", value: "Março" },
                { id: "04", value: "Abril" },
                { id: "05", value: "Maio" },
                { id: "06", value: "Junho" },
                { id: "07", value: "Julho" },
                { id: "08", value: "Agosto" },
                { id: "09", value: "Setembro" },
                { id: "10", value: "Outubro" },
                { id: "11", value: "Novembro" },
                { id: "12", value: "Dezembro" }
            ],
            tecnico: null,
            dataHoraAtual: null,
        };
    },

    mounted() {
        this.getTecnico();
        this.definirDataHoraAtual();
    },

    methods: {

        getMes(mes) {
            const result = this.meses.filter(item => item.id == this.mes);
            return result[0] ? result[0].value : "";
        },

        getTecnico() {
            const userId = this.$store.state.user.id;

            axios.get(`/api/dashboard/tecnico/get/user_id/${userId}`).then((response) => {
                this.tecnico = response.data.data;
            })
            .catch((error) => {
                console.error("Erro ao buscar técnico:", error);
            });
        },

        definirDataHoraAtual() {
            const agora = new Date();
            const dataFormatada = agora.toLocaleDateString("pt-BR");
            const horaFormatada = agora.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
            });
            this.dataHoraAtual = `${dataFormatada} ${horaFormatada}`;
        },

    }
};
</script>
